// extracted by mini-css-extract-plugin
module.exports = {"tooltip-container":"TooltipGoftino_tooltip-container__1JCUs","icon":"TooltipGoftino_icon__QMzPu","tooltip":"TooltipGoftino_tooltip__JwjLa"};